import React from 'react';

import ExamPicker from '@components/libraryV2/ExamPicker';
import Heading from '@components/libraryV2/Heading';
import HeroStretch from '@components/libraryV2/HeroStretch';
import ThemeText from '@components/libraryV2/ThemeText';

import * as styles from './styles.module.scss';

const HomeHero = () => (
  <HeroStretch
    className={styles.centered}
    title={
      <Heading className={styles.title} tagType="h1">
        <div>Ace it with</div>
        <ThemeText noWrap>Achievable</ThemeText>
      </Heading>
    }
    titleClass={styles.titleContainer}
    description={
      <div className={styles.description}>
        Fun, effective, and efficient interactive exam prep courses
      </div>
    }
    hideBackground
  >
    <ExamPicker />
  </HeroStretch>
);

export default HomeHero;
